export const getError = (
  data: { server_error?: string; error?: string },
  defaultMessage: string = 'Something went wrong'
): string => {
  return data?.server_error || data?.error || defaultMessage
}

export const humanizeErrors = (errors: ApiError[]) => {
  return errors.map((err: ApiError) => err.message).join(', ')
}
